const SETTLEMENT_TRANSIT_ACCOUNTS = "/backoffice/settlement-transit-account";

export const TRANSIT_ACCOUNT_ROUTES = {
  SETTLEMENT_TRANSIT_ACCOUNTS,
};
